module.exports = __webpack_public_path__ + "admin/img/ibobee_logo@2x.f05835ae.png";